import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Productos from './pages/Productos';
import Categorias from './pages/Categorias';
import LoNuevo from './pages/LoNuevo';
import Contacto from './pages/Contacto';
import BrandDetail from './pages/BrandDetail';
import Login from './pages/Login';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import BrandsAdmin from './pages/admin/BrandsAdmin';
import ProductsAdmin from './pages/admin/ProductsAdmin';
import CategoriesAdmin from './pages/admin/CategoriesAdmin';
import PostsAdmin from './pages/admin/PostsAdmin';
import UsersAdmin from './pages/admin/UsersAdmin';
import CosmeticsAdmin from './pages/admin/CosmeticsAdmin';
import ProtectedRoute from './components/ProtectedRoute';
import InstallPrompt from './components/InstallPrompt';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App min-h-screen bg-[#eef8e8] text-slate-900">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/productos" element={<Productos />} />
              <Route path="/categorias" element={<Categorias />} />
              <Route path="/lo-nuevo" element={<LoNuevo />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/brands/:id" element={<BrandDetail />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="marcas" element={<BrandsAdmin />} />
                <Route path="productos" element={<ProductsAdmin />} />
                <Route path="categorias" element={<CategoriesAdmin />} />
                <Route path="cosmeticos" element={<CosmeticsAdmin />} />
                <Route path="lo-nuevo" element={<PostsAdmin />} />
                <Route path="usuarios" element={<UsersAdmin />} />
              </Route>
            </Routes>
          </main>
          <Footer />
          <Toaster />
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
